import { useQuery } from '@tanstack/react-query';
import VANITY_URL_KEYS from '../vanityUrl.keys';
import VANITY_URL_QUERIES from '../vanityUrl.queries';

export const useCheckVanityUrlAvailability = (vanityUrl, options = {}) =>
  useQuery({
    queryKey: VANITY_URL_KEYS.AVAILABILITY(vanityUrl),
    queryFn: () => VANITY_URL_QUERIES.CHECK_AVAILABILITY(vanityUrl),
    enabled: !!vanityUrl && vanityUrl.length > 0,
    retry: false,
    staleTime: 0,
    ...options,
  });
